<button mat-button (click)="deleteConfig(); $event.stopPropagation();">Delete</button>
<div *ngIf="config.appliedScope != 'PRODUCTION'">
    <button mat-raised-button (click)="showUpdateToProductionDialog(); $event.stopPropagation();">Use as production</button>
</div>